module.exports = __webpack_public_path__ + "static/media/image2.bfa11bf9.png";